import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import './App.css';
import ScrollToTopButton from './pages/ScrollToTopButton'
import AppRoutes from './AppRoutes';
import { MenuProvider } from './components/context/MenuContext';

function App() {
  return (
    <Router>
      <MenuProvider> {/* Wrap the entire app with the MenuProvider */}
        <div className="App">
          <Header />
          <main className="App-body">
            <AppRoutes />
          </main>
          <Footer />
          <ScrollToTopButton />
        </div>
      </MenuProvider>
    </Router>
  );
}

export default App;

